// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2o778","topBottomGutter":"Layout_topBottomGutter__a_orE"};